import React from "react";
import { wwlogo } from "../../assets";
import { Link } from "react-router-dom";

const HeroSection = () => {
  // const images = [
  //   "https://media.discordapp.net/attachments/920721313105080390/1305567631969095802/image.png?ex=6733801b&is=67322e9b&hm=c5bf17718c64f31c0426da5df426eafc26fe349a3433c6e0f02e4093a3394e33&=&format=webp&quality=lossless&width=686&height=686",
  // ];

  // const [currentImage, setCurrentImage] = useState(0);
  // const [fade, setFade] = useState(true);

  // Cycle through images every 5 seconds

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setFade(false); // Trigger fade out
  //     setTimeout(() => {
  //       setCurrentImage((prevImage) => (prevImage + 1) % images?.length);
  //       setFade(true); // Trigger fade in
  //     }, 500); // Wait for fade-out duration before switching
  //   }, 5000);
  //   return () => clearInterval(interval);
  // }, [images?.length]);

  return (
    <section className="bg-secondary relative lg:max-h-[670px] md:max-h-[515px] sm:min-h-[515px] flex flex-col items-center justify-center text-center  overflow-hidden">
      {/* Background Images with Fade */}
      {/* <div
        className={`absolute inset-0 bg-secondary bg-contain transition-opacity duration-1000 ease-in-out bg-center bg-no-repeat ${
          fade ? "opacity-100" : "opacity-0"
        }`}
        style={{
          backgroundImage: `url(${dark_hero_bg_svg})`,
        }}
      ></div> */}

      {/* Overlay */}

      {/* <div className=" absolute inset-0 bg-black opacity-40 lg:hidden md:block sm:block"></div> */}

      {/* Main Content */}

      {/* <div className="bg-secondary w-full flex justify-center items-center">
        <img src={wwlogo} alt="" />
      </div> */}

      {/*it was relative */}
      <div className=" py-10 z-10 container mx-auto max-w-[1200px] flex flex-col items-center justify-center lg:text-black md:text-white sm:text-white lg:px-4 md:px-4 sm:px-2">
        <h1 className="lg:text-2xl md:text-xl font-semibold mb-4 lg:w-3/4 md:w-3/4 sm:w-full text-primary">
          Connecting Luxury Watch Dealers Worldwide.
        </h1>

        <img src={wwlogo} alt="" className="my-4 lg:h-[300px] md:h-[180px]" />

        <p className="text-center text-white text-[16px] ">
          Welcome to WristLink – the exclusive B2B marketplace designed for
          luxury watch professionals. Trade with confidence on a secure,
          commission-free platform and grow your network through direct
          connections.
        </p>

        {/* Rating Section */}
        <div className="mb-6 text-center text-sm">
          {/* <div className="mb-3 flex justify-center items-center">
            <span className="flex">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="py-1.5 px-0.5 text-primary">
                  {StarFill}
                </span>
              ))}
            </span>
            <span className="ml-2">(165,361)</span>
          </div> */}

          {/* <div className="flex items-center justify-center">
            <span className="mr-2">Powered by</span>
            <a href="#trustpilot">
              <img
                src="https://static.chrono24.com/images/default/trustpilot-logo-dark.svg"
                alt="Trustpilot"
                width="100"
                height="25"
              />
            </a>
            
          </div> */}

          <div className="flex gap-3 items-center mt-4 mx-auto">
            <Link
              to={"/dealer-info/subcription-plan"}
              className="px-6 py-3 rounded-lg text-secondary font-bold bg-primary"
            >
              Get Started
            </Link>
            <Link
              to={"/learn-more"}
              className="px-6 py-3 rounded-lg text-secondary font-bold bg-primary"
            >
              Learn More
            </Link>
          </div>
        </div>

        {/* Link */}
        {/* <a
          href="/watches/dress-watches-elegant-evening-watches--54.htm"
          className="text-sm  underline"
        >
          Over 18,600 results for dress watches
        </a> */}
      </div>
    </section>
  );
};

export default HeroSection;
